import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import useLogOut from "../hooks/useLogOut.js";

const RegionBlocker = () => {
  const { core_region_access, token } = useSelector((state) => ({
    core_region_access: state.core_region_access,
    token: state.token,
  }));
  const { logout } = useLogOut();
  const history = useHistory();
  const location = useLocation();

  // Handle route changes - show popup on all admin routes except logout, plans, and payment routes
  useEffect(() => {
    if (token && !core_region_access) {
      const isExcludedRoute =
        location.pathname.includes("logout") ||
        location.pathname.includes("/plans") ||
        location.pathname.includes("/payment") ||
        location.pathname.includes("/sub/") ||
        location.pathname.includes("/ccav/");

      // Show popup on all admin routes except excluded routes
      if (location.pathname.startsWith("/admin/") && !isExcludedRoute) {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent("showRegionPopup"));
        }, 100);
      }
    }
  }, [token, core_region_access, location.pathname]);

  // Handle click interception - don't prevent navigation, just show popup
  useEffect(() => {
    if (token && !core_region_access) {
      const handleClick = (e) => {
        const link = e.target.closest("a");
        if (link && link.href) {
          // Check if it's an excluded link - allow without popup
          const isExcludedLink =
            link.textContent?.toLowerCase().includes("logout") ||
            link.href?.includes("/auth/logout") ||
            link.getAttribute("href")?.includes("/auth/logout") ||
            link.closest("li")?.classList.contains("logout-item") ||
            link.href?.includes("/plans") ||
            link.href?.includes("/payment") ||
            link.href?.includes("/sub/") ||
            link.href?.includes("/ccav/");

          if (isExcludedLink) {
            // Allow excluded links to work normally without popup
            return;
          }

          // For all other sidebar links, show popup but allow navigation
          const pathname = new URL(link.href).pathname;
          if (pathname.startsWith("/admin/")) {
            // Don't prevent navigation, just show popup
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent("showRegionPopup"));
            }, 50);
          }
        }
      };

      document.addEventListener("click", handleClick, true);
      return () => document.removeEventListener("click", handleClick, true);
    }
  }, [token, core_region_access]);

  return null;
};

export default RegionBlocker;
